import { render, staticRenderFns } from "./BrandItem.vue?vue&type=template&id=429731d0&scoped=true"
import script from "./BrandItem.vue?vue&type=script&lang=js"
export * from "./BrandItem.vue?vue&type=script&lang=js"
import style0 from "./BrandItem.vue?vue&type=style&index=0&id=429731d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429731d0",
  null
  
)

export default component.exports